/**
 * Build Information
 * Auto-generated during GitHub Actions deployment
 * DO NOT EDIT MANUALLY - This file is overwritten on each build
 */

export const BUILD_INFO = {
  version: import.meta.env.VITE_APP_VERSION || 'dev',
  buildNumber: import.meta.env.VITE_BUILD_NUMBER || 'local',
  commitSha: import.meta.env.VITE_COMMIT_SHA || 'unknown',
  buildDate: import.meta.env.VITE_BUILD_DATE || new Date().toISOString(),
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
  runNumber: import.meta.env.VITE_RUN_NUMBER || '0'
};

// Log build info to console (production and staging only)
if (['production', 'staging'].includes(BUILD_INFO.environment)) {
  const envLabel = BUILD_INFO.environment === 'production' ? 'Production' : 'Staging';
  const envColor = BUILD_INFO.environment === 'production' ? '#10b981' : '#f59e0b';
  console.log(
    '%c🚀 ADU Lab %c' + envLabel,
    'font-size: 16px; font-weight: bold; color: #2563eb;',
    `font-size: 16px; font-weight: bold; color: ${envColor};`
  );
  console.log(
    `%cBuild #${BUILD_INFO.runNumber} %c• %c${BUILD_INFO.commitSha.substring(0, 7)}`,
    'color: #6366f1; font-weight: bold;',
    'color: #94a3b8;',
    'color: #64748b; font-family: monospace;'
  );
  console.log(
    `%cDeployed: %c${new Date(BUILD_INFO.buildDate).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short'
    })}`,
    'color: #94a3b8;',
    'color: #64748b;'
  );
  console.log('%c──────────────────────────────', 'color: #e2e8f0;');
}

export default BUILD_INFO;
